import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';

export class SubLocation extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'sub_locations';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      parent_location_id: this.attr(null),
      location: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default SubLocation;
